export default "__VITE_ASSET__PZ8zW$NA__"